import { CultureInfo } from '../culture-info.model';
import { CultureInfoKs } from './ks';

/**
 * @ignore
 */
export const CultureInfoKsAran: CultureInfo = {
  name: 'ks-Aran',
  displayName: 'کٲشُر',
  iso3LanguageCode: 'kas',
  iso2LanguageCode: 'ks',
  ietfLanguageTag: 'ks-Aran',
  parent: CultureInfoKs
};
